/** VANS envelopes for an outbox row (C16–C18). Shapes returned by communicate-ctl. */

export type VansTransport = 'reliable' | 'unreliable' | 'none';

export const VANS_TRANSPORTS: VansTransport[] = ['reliable', 'unreliable', 'none'];

export type VansAttemptStatus = 'awaiting' | 'positive' | 'negative';

export type VansAttemptReceipt = {
  id: string;
  kind: string;
  errorCode: string | null;
  errorText: string | null;
  matchesSent: boolean;
  createdAt: string;
};

export type VansAttempt = {
  id: string;
  envelopeIdentifier: string;
  messageIdentifier: string | null;
  transport: VansTransport;
  sizeInBytes: number | null;
  documentName: string | null;
  createdAt: string;
  receipts: VansAttemptReceipt[];
  status: VansAttemptStatus;
};

export type VansAttemptsResult = {
  exchanges: { exchangeId: string; attempts: VansAttempt[] }[];
};

/** Transport/Type unreliable asks for no VANS receipt, so it never waits for one. */
export function vansStatusExpectsReceipt(attempt: Pick<VansAttempt, 'transport'>): boolean {
  return attempt.transport !== 'unreliable';
}

/** The receipt that decides the status: the newest negative, else the newest positive. */
export function decidingVansReceipt(attempt: Pick<VansAttempt, 'receipts'>): VansAttemptReceipt | null {
  const newestFirst = [...attempt.receipts].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  return (
    newestFirst.find((r) => r.kind !== 'PositiveMessage') ??
    newestFirst.find((r) => r.kind === 'PositiveMessage') ??
    null
  );
}

/** A VANSEnvelope is UTF-8 (VANS-S 2.7), so the string is written as UTF-8. */
export function downloadUtf8Xml(xml: string, filename: string): void {
  const blob = new Blob([xml], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
